import { __styles, mergeClasses } from '@griffel/core';
import { useRenderer_unstable } from '@griffel/react';
import { tokens, typographyStyles } from '@fluentui/react-theme';
export const fluentProviderClassNames = {
  root: 'fui-FluentProvider'
};

const useStyles = /*#__PURE__*/__styles({
  "root": {
    "sj55zd": "f19n0e5",
    "De3pzq": "fxugw4r",
    "fsow6f": ["f1o700av", "fes3tcz"],
    "Bahqtrf": "fk6fouc",
    "Be2twd7": "fkhj508",
    "Bhrd7zp": "figsok6",
    "Bg96gwp": "f1i3iumi"
  }
}, {
  "d": [".f19n0e5{color:var(--colorNeutralForeground1);}", ".fxugw4r{background-color:var(--colorNeutralBackground1);}", ".f1o700av{text-align:left;}", ".fes3tcz{text-align:right;}", ".fk6fouc{font-family:var(--fontFamilyBase);}", ".fkhj508{font-size:var(--fontSizeBase300);}", ".figsok6{font-weight:var(--fontWeightRegular);}", ".f1i3iumi{line-height:var(--lineHeightBase300);}"]
});
/** Applies style classnames to slots */


export const useFluentProviderStyles_unstable = state => {
  const renderer = useRenderer_unstable();
  const styles = useStyles({
    dir: state.dir,
    renderer
  });
  state.root.className = mergeClasses(fluentProviderClassNames.root, state.themeClassName, styles.root, state.root.className);
  return state;
};
//# sourceMappingURL=useFluentProviderStyles.js.map